/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCDownIcon64Regular = forwardRef('ArrowCDownIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M54.06 21.94a1.5 1.5 0 0 1 0 2.12L37.304 40.819a7.5 7.5 0 0 1-10.606 0L9.939 24.061a1.5 1.5 0 0 1 2.122-2.122l16.757 16.758a4.5 4.5 0 0 0 6.364 0l16.757-16.758a1.5 1.5 0 0 1 2.122 0Z" })));
});
